import { CONSENT_ADVERTISING } from "../events";
import { injectScript } from "./script";

/**
 * LinkedIn Ads (Insight Tag, snippet oficial). Só com consentimento de advertising.
 *
 * A Insight Tag registra a visualização de página sozinha. Cada evento do funil só gera conversão se o cliente
 * informou o ID da conversão (criada no Campaign Manager) para ele: lintrk('track', { conversion_id }).
 */
export default {
    name: "linkedin",

    isAllowed(config, allowed) {
        return !!(config && config.partner_id) && allowed(CONSENT_ADVERTISING);
    },

    init(config) {
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(String(config.partner_id));

        if (!window.lintrk) {
            window.lintrk = function (action, payload) {
                window.lintrk.q.push([action, payload]);
            };
            window.lintrk.q = [];
        }

        injectScript("https://snap.licdn.com/li.lms-analytics/insight.min.js");
    },

    send(eventName, payload, config) {
        const conversionId = config.conversion_ids ? config.conversion_ids[eventName] : null;
        if (!conversionId || typeof window.lintrk !== "function") {
            return;
        }

        window.lintrk("track", { conversion_id: Number(conversionId), event_id: payload.event_id });
    },
};
